module.exports = {
      id: "email-usage",
      viewBox: "0 0 22 17",
      url: __webpack_public_path__ + "images/sprites/social.svg#email-usage",
      toString: function () {
        return this.url;
      }
    }